// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1iojT","savePackageButton":"ClientWallet_savePackageButton__2g5Co"};